import { ClientAttachmentId } from 'owa-client-ids';
import InfoBarMessageViewStateCreator from 'owa-info-bar/lib/schema/InfoBarMessageViewStateCreator';
import { ComposeViewState } from 'owa-mail-compose-store';
import { findComposePlugins } from 'owa-mail-compose-store/lib/plugins/ComposePlugins';
import createAttachments from 'owa-mail-compose-store/lib/utils/createAttachments';
import { createLocalComputerFiles } from 'owa-attachment-file-types';
import {
    infoBarAddHandler,
    infoBarRemoveHandler,
} from 'owa-mail-compose-store/lib/utils/infoBarHandlers';
import { ApiErrorCode } from 'owa-addins-core';
import { AttachmentBlob } from 'owa-mail-compose-store/lib/utils/attachmentBlob';
import { isImageFile } from 'owa-file';

export default function createAttachmentFromBase64String(
    viewState: ComposeViewState,
    base64String: string,
    attachmentName: string,
    isInline: boolean
): Promise<string> {
    return new Promise<string>((resolve, reject) => {
        let hasProcessed = false;
        const handler = infoBarAddHandler(viewState);

        const attachmentErrorHandler = (
            messageId: string,
            infoBarMessageViewStateCreator: InfoBarMessageViewStateCreator
        ) => {
            handler(messageId, infoBarMessageViewStateCreator);
            if (!hasProcessed) {
                hasProcessed = true;
                reject({ errorType: 'UploadError', id: messageId });
            }
        };

        const onFinish = (attachmentId: ClientAttachmentId) => {
            if (!hasProcessed) {
                hasProcessed = true;
                resolve(attachmentId.Id);
            }
        };

        try {
            const attachmentContent = atob(base64String);
            const attachmentContentLength = attachmentContent.length;
            const byteArray = new Uint8Array(new ArrayBuffer(attachmentContentLength));

            for (let i = 0; i < attachmentContentLength; i++) {
                byteArray[i] = attachmentContent.charCodeAt(i);
            }

            var blob = null;
            if (isImageFile(attachmentName)) {
                blob = new Blob([byteArray], { type: 'image/png' });
            } else {
                blob = new Blob([byteArray]);
            }

            var attachmentBlob: AttachmentBlob = blob;
            attachmentBlob.name = attachmentName;

            const localComputerFileList = createLocalComputerFiles([<File>attachmentBlob]);

            const composePlugins = findComposePlugins(viewState);
            const inlineImagePlugin = composePlugins.inlineImagePlugin;
            const isPlainText = viewState.bodyType != 'HTML';
            const processInlineImageBeforeUpload = isPlainText
                ? null
                : inlineImagePlugin.processInlineImageBeforeUpload.bind(inlineImagePlugin);

            createAttachments(
                localComputerFileList,
                viewState,
                {
                    isInline,
                    isHiddenInline: true,
                    shouldShare: false,
                },
                processInlineImageBeforeUpload,
                attachmentErrorHandler,
                infoBarRemoveHandler(viewState),
                onFinish
            );
        } catch (err) {
            reject({ errorType: ApiErrorCode.AttachmentUploadGeneralFailure });
        }
    });
}
